import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { ImageCropperComponent } from 'ngx-image-cropper';
import { UploadImageComponent } from './upload-image.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    TranslateModule.forChild(),
    ImageCropperComponent,
  ],
  declarations: [UploadImageComponent],
  exports: [UploadImageComponent],
})
export class UploadImageModule {}
